export default {
  SET_FORMULARIO: 'SET_FORMULARIO',
  SET_CARREGANDO_DADOS: 'SET_CARREGANDO_DADOS',
  SET_MANIPULANDO_DADOS: 'SET_MANIPULANDO_DADOS',
  SET_FLAGS_RETORNO: 'SET_FLAGS_RETORNO'
}
